"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$articleGroup = exports.articleGroupToLines = void 0;
const line_1 = require("../../../node/cst/line");
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const util_1 = require("../../../util");
const factory_1 = __importDefault(require("../factory"));
const util_2 = require("../util");
const _paragraphItem_1 = require("./$paragraphItem");
const util_3 = require("../../cst/util");
const _article_1 = __importStar(require("./$article"));
const num_1 = require("../../../law/num");
const _appdxItem_1 = require("./$appdxItem");
const error_1 = require("../../cst/error");
const inline_1 = require("../../../node/cst/inline");
const el_1 = require("../../../node/el");
/**
 * The renderer for article group ({@link std.ArticleGroup | ArticleGroup}) such as Chapter. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$articleGroup.spec.ts) for examples.
 */
const articleGroupToLines = (el, indentTexts) => {
    const lines = [];
    const ChildItems = [];
    for (const child of el.children) {
        if (std.isArticleGroupTitle(child)) {
            const titleIndentDepth = indentTexts.length === 0
                ? std.articleGroupTitleTags.indexOf(child.tag) + 2
                : indentTexts.length;
            const titleIndentTexts = indentTexts.length === 0
                ? [...(0, util_1.range)(0, titleIndentDepth)].map(() => toCSTSettings_1.default.INDENT)
                : indentTexts;
            lines.push(new line_1.ArticleGroupHeadLine({
                range: null,
                indentTexts: titleIndentTexts,
                mainTag: el.tag,
                controls: indentTexts.length == 0 ? [] : [
                    new inline_1.Control(":keep-indents:", null, "", null)
                ],
                sentenceChildren: (0, util_3.mergeAdjacentTextsWithString)(child.children),
                lineEndText: toCSTSettings_1.default.EOL,
            }));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else {
            ChildItems.push(child);
        }
    }
    for (const [i, child] of ChildItems.entries()) {
        if (i > 0)
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        if (child.tag === "Article") {
            lines.push(...(0, _article_1.articleToLines)(child, indentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if (child.tag === "Paragraph") {
            lines.push(...(0, _paragraphItem_1.paragraphItemToLines)(child, indentTexts, { defaultTag: "Paragraph" }));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if (std.isArticleGroup(child)) {
            lines.push(...(0, exports.articleGroupToLines)(child, indentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if (std.isAppdxStyle(child)) {
            console.error("Unexpected AppdxStyle in MainProvision!");
            lines.push(...(0, _appdxItem_1.appdxItemToLines)(child, indentTexts));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return lines;
};
exports.articleGroupToLines = articleGroupToLines;
/**
 * The parser rule for article group ({@link std.ArticleGroup | ArticleGroup}) such as Chapter. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$articleGroup.spec.ts) for examples.
 */
exports.$articleGroup = factory_1.default
    .withName("articleGroup")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.ARG) {
        return item;
    }
    else {
        return null;
    }
}), "headLine")
    .and(r => r
    .zeroOrMore(r => r
    .sequence(r => r
    .andOmit(r => r.zeroOrMore(() => util_2.$blankLine))
    .and(r => r
    .choice(r => r
    .or(() => _article_1.default)
    // .or(() => $paragraphItem)
    .orSequence(s => s
    .andOmit(r => r
    .nextIs(r => r
    .oneMatch(({ item, headLine }) => {
    if (item.type === line_1.LineType.ARG
        && std.articleGroupTags.indexOf(headLine.line.mainTag) < std.articleGroupTags.indexOf(item.line.mainTag)) {
        return item;
    }
    else {
        return null;
    }
})))
    .and(() => exports.$articleGroup))
    .or(r => r
    .asSlice(r => r
    .oneOrMore(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(() => util_2.$indentBlock)
    .orSequence(s => s
    .and(r => r.anyOne(), "captured")
    .andOmit(r => r.assert(({ captured }) => (captured.type === line_1.LineType.OTH)
    || (captured.type === line_1.LineType.PIT)))))))))))))), "childrenAndErrors")
    .action(({ headLine, childrenAndErrors }) => {
    const children = [];
    const errors = [];
    for (const child of childrenAndErrors) {
        if (Array.isArray(child)) {
            errors.push(new error_1.ErrorMessage("$articleGroup: この部分をパースできませんでした。", [
                child[0].virtualRange[0],
                child.slice(-1)[0].virtualRange[1],
            ]));
        }
        else {
            children.push(child.value);
            errors.push(...child.errors);
        }
    }
    const articleGroup = (0, std_1.newStdEL)(headLine.line.mainTag);
    articleGroup.children.push((0, std_1.newStdEL)(std.articleGroupTitleTags[std.articleGroupTags.indexOf(headLine.line.mainTag)], {}, headLine.line.title, headLine.line.titleRange));
    const num = (0, num_1.parseNamedNum)(typeof headLine.line.title[0] === "string"
        ? headLine.line.title[0]
        : headLine.line.title[0]?.text());
    if (num) {
        articleGroup.attr.Num = num;
    }
    articleGroup.children.push(...children);
    const pos = headLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(articleGroup.children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    articleGroup.range = range;
    return {
        value: articleGroup,
        errors,
    };
}));
exports.default = exports.$articleGroup;
//# sourceMappingURL=$articleGroup.js.map